var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H31.9956C40.8322 0 47.9956 7.16344 47.9956 16V31.9956C47.9956 40.8322 40.8322 47.9956 31.9956 47.9956H16C7.16344 47.9956 0 40.8322 0 31.9956V16Z",
    fill: "#2F91F8",
    fillOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9932 13.9988V33.9969",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9926 16.9985H21.4933C20.5652 16.9985 19.675 17.3673 19.0187 18.0236C18.3624 18.6799 17.9937 19.57 17.9937 20.4982C17.9937 21.4264 18.3624 22.3165 19.0187 22.9729C19.675 23.6292 20.5652 23.9979 21.4933 23.9979H26.4929C27.421 23.9979 28.3112 24.3666 28.9675 25.0229C29.6238 25.6792 29.9926 26.5694 29.9926 27.4976C29.9926 28.4257 29.6238 29.3159 28.9675 29.9722C28.3112 30.6285 27.421 30.9973 26.4929 30.9973H17.9937",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticon04);
export default __webpack_public_path__ + "static/media/staticon04.a0b4196eb010109c631d0100d98f502a.svg";
export { ForwardRef as ReactComponent };